import type { Scope, UUID } from '@/api/types';

export type Grants = Record<string, Scope>;

/**
 * Mirrors the backend: ALL allows everything, ASSIGNED only records assigned to the user. Without a known
 * assignee (a list, a new record) ASSIGNED is enough to try: the server decides per record.
 */
export function can(grants: Grants | undefined, code: string, assignee?: UUID | null, me?: UUID): boolean {
  const scope = grants?.[code];
  if (!scope) return false;
  if (scope === 'ALL') return true;
  if (assignee === undefined) return true;
  return assignee !== null && assignee === me;
}

export function canAny(grants: Grants | undefined, ...codes: string[]): boolean {
  return codes.some((c) => can(grants, c));
}
